
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestfloorcleaningmachines",
      function () {
        return require("private-next-pages/bestfloorcleaningmachines/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestfloorcleaningmachines"])
      });
    }
  